import { handleActions } from 'redux-actions'
import { setLoadingExport, setLoadingExportDone, setLoadingJoinGoal, setLoadingJoinGoalDone } from './loadingActions'

class State {
  joinGoal = false
  export = false
}

export const loading = handleActions<State, any>(
  {
    [String(setLoadingJoinGoal)]: (state: State): State => ({
      ...state,
      joinGoal: true,
    }),
    [String(setLoadingJoinGoalDone)]: (state: State): State => ({
      ...state,
      joinGoal: false,
    }),
    [String(setLoadingExport)]: (state: State): State => ({
      ...state,
      export: true,
    }),
    [String(setLoadingExportDone)]: (state: State): State => ({
      ...state,
      export: false,
    }),
  },
  new State(),
)

export { State as LoadingState }
